import React from 'react'
import InfoIcon from '@material-ui/icons/Info';
import {Avatar} from '@material-ui/core'
import HomeIcon from '@material-ui/icons/Home';
import { AiOutlineBars } from 'react-icons/ai';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
const Container = styled.nav`
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  display:flex;
  height:80px;
  width:100vw;
  justify-content:space-evenly;
  align-items:center;
  box-shadow:0 -1px 4px 0 rgb(26 26 26 / 8%), 0 4px 8px 0 rgb(26 26 26 / 12%);
  z-index:999;
  background:white
`
const LeftContainer = styled(Avatar)`
  height:100%;
  object-fit:cover;
  
`
const MidContainer = styled.div`

  height:100%;
  padding-top:15px;
`
const RightContainer = styled(AiOutlineBars)`
  height:100%;
  display:none;

  
`


const Navbar = () => {
  return (
    <Container> 
      <LeftContainer style={{ marginLeft: '10px', fontSize: '300px' }}
        src='https://avatars.githubusercontent.com/u/24513658?s=400&u=4b57ef944d1d54524b4b94c04084db3134ff4429&v=4'
      />
      {/* <MidContainer>
        <Link to='#'>
        <HomeIcon style={{  fontSize: 40, color: '#F7EF8A' }}/>
        <InfoIcon style={{ marginLeft:'50px',fontSize: 40, color: '#F7EF8A' }} />
        </Link>
      </MidContainer> */}
      <RightContainer style={{ fontSize: 40 ,marginRight:'20px'}}/>
    </Container>
  )
}

export default Navbar
